NP.WriteShort = (function( $ ) {
	var writeShort = {},
		writeWrap = $( '#writeShort' ),
		editorShort  = writeWrap.find( '.wrap_editorShort' ),
		welcome = editorShort.find( '.welcome span' );

	if( !writeWrap.length ){
		return;
	};
	
	var setPlaceHolderTxt = function(){
		var s = '';

		if( NP.dt.page === 'group' ){
			s = '우리들만의 이야기를 나눠보세요.';
		}else if( NP.dt.page === 'groupguestbook' ){
			//s = '[' + NP.dt.gNm + '] 레기온에 반가운 이야기를 남겨보세요.';
			s = '반가운 이야기를 남겨보세요.';
		}else if( NP.dt.page === 'characterguestbook' ){
			//s = '[' + NP.dt.oNm + ']님에게 반가운 이야기를 남겨보세요.';
			s = '반가운 이야기를 남겨보세요.';
		}else if( NP.dt.page === 'wall' ){
			s = '반가운 이야기를 남겨보세요.';
		}else if( NP.dt.page === 'timeline' ){
			s = '오늘은 어떤 이야기를 나누실래요?';
		}

		return s;
	};
	
	var setPlaceHolder = function(){
		$( '#writeShort' ).find( '.welcome span' ).html( setPlaceHolderTxt() );
	};
	
	NP.onAfterTimelineLoad.add(function() {
		setPlaceHolder();
	});	
	
	
	//이미 editor가 붙어 있는 경우
	if( writeWrap.find( '.wrap_editorShort' ).length ){
		return;
	};
	
	welcome.html( '' );
	writeWrap.append( NP.tmpl.writeShort );

	return writeShort;
}( jQuery ));